module.exports = __webpack_public_path__ + "fonts/Mukta-500-latin-ext11.dcb8bef.woff2";